import React from "react";
import configService from "../services/configService";
import { isAlphaDevPreviewEnvironment } from "./alpha/alphaDevPreview";
import ProductSharePageV2 from "./ProductSharePageV2";
import {
  PRODUCT_SHARE_DEV_PREVIEW_SHARE,
  PRODUCT_SHARE_DEV_PREVIEW_STATS,
} from "./productShareDevPreviewData";

/**
 * /product-share/dev-preview: the share page with production-like content on
 * the local and dev environments, for design work. Everywhere else the route
 * behaves like any unknown share token and shows the not-found state.
 */
const ProductShareDevPreviewPage: React.FC = () => {
  if (!isAlphaDevPreviewEnvironment(configService.getEnvironment())) {
    return <ProductSharePageV2 />;
  }
  return (
    <ProductSharePageV2
      preview={{
        share: PRODUCT_SHARE_DEV_PREVIEW_SHARE,
        stats: PRODUCT_SHARE_DEV_PREVIEW_STATS,
      }}
    />
  );
};

export default ProductShareDevPreviewPage;
